import { Box } from '@chakra-ui/react';
import { NextPage } from 'next';
import React from 'react';

import MainLayout from '@app/components/MainLayout';
import { PageTitle } from '@app/components/PageTitle';
import { PositionsList } from '@app/screens/positions/components/PositionsList';
import { APP_NAME } from '@app/constants/common';
import { CreatePositionButton } from '@app/screens/positions/components/CreatePositionButton';

export const PositionsPage: NextPage = () => {
  return (
    <MainLayout metadata={{ title: `My Liquidity | ${APP_NAME}` }}>
      <Box width="100%" mt="56px" maxWidth="612px" mx="auto" px={['16px', 0]}>
        <PageTitle title="My Liquidity">
          <CreatePositionButton />
        </PageTitle>
        <Box mt="40px">
          <PositionsList />
        </Box>
      </Box>
    </MainLayout>
  );
};

export default PositionsPage;
